// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/ditching.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/ditching/ditching.js';

mount([g0]);
